(ns frontend.view.grid.fundraising-opportunities-grid.db
  (:require [frontend.db :as app-db]
            [reagent.core :as r]))

(defonce fundraising-opportunities (r/cursor app-db/views [:fundraising-opportunities-grid]))
(defonce modal-state (r/cursor fundraising-opportunities [:modals]))
(defonce grid-entities (r/cursor fundraising-opportunities [:grid-entities]))
(defonce view-settings (r/cursor fundraising-opportunities [:view-settings]))
(defonce fundraising-opportunity-filters (r/cursor view-settings [:filters]))
(defonce selected-columns (r/cursor view-settings [:selected-columns]))
(defonce column-widths (r/cursor view-settings [:column-widths]))
(defonce ordered-columns (r/cursor view-settings [:ordered-columns]))

;;kanban related definitions
(defonce kanban (r/cursor fundraising-opportunities [:kanban]))
(defonce expanded (r/cursor kanban [:expanded]))
(defonce grouped-by (r/cursor view-settings [:grouped-by]))
(defonce card-settings (r/cursor view-settings [:card-settings]))
(defonce lists (r/cursor kanban [:lists]))
(defonce sorted-kanban-entities (r/cursor fundraising-opportunities [:sorted-kanban-entities]))

;;precalculated schema (for performance reasons):
(defonce schema (r/cursor fundraising-opportunities [:schema]))
